// documents.ts

import {
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { CommonModule } from '@angular/common';

import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import { Subscription } from 'rxjs';

import { Document } from '../../leads/document/document';

import { OnboradingService } from '../shared/service/onboarding.service';
import { MODULE_SEQ } from '../../../core/shared/models/picklist.model';
import { TranslatePipe } from '@ngx-translate/core';



@Component({
  selector: 'app-documents',
  standalone: true,
  imports: [
    CommonModule,
    Document,
    TranslatePipe,
  ],
  templateUrl: './documents.html',
  styleUrl: './documents.css',
})
export class Documents
  implements OnInit, OnDestroy {

  // =====================================
  // VARIABLES
  // =====================================

  crptOnbrdngSeq:
    number | null = null;

  clntSeq:
    number | null = null;

  isViewMode = false;

  // =====================================
  // MODULE SEQ
  // =====================================

  readonly MODULE_SEQ =
    MODULE_SEQ;

  // =====================================
  // SUBSCRIPTIONS
  // =====================================

  private subs:
    Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private onboarding: OnboradingService,
  ) {}

  // =====================================
  // INIT
  // =====================================

  ngOnInit(): void {

    // route params
    this.subs.push(

      this.route.paramMap.subscribe(
        (params) => {

          const id =
            params.get('id');

          if (id) {

            this.crptOnbrdngSeq =
              +id;

            this.onboarding
              .setCorporateSeq(
                +id
              );

          }

        }
      )

    );

    // query params
    this.subs.push(

      this.route.queryParamMap.subscribe(
        (q) => {

          const clientSeq =
            q.get('clientSeq');

          if (clientSeq) {

            this.clntSeq =
              +clientSeq;

            this.onboarding
              .setClientSeq(
                +clientSeq
              );

          }

          this.isViewMode =
            q.get('mode') === 'view';

        }
      )

    );

    // client seq observable
    this.subs.push(

      this.onboarding
        .clntSeq$
        .subscribe((seq) => {

          if (seq) {

            this.clntSeq =
              seq;

          }

        })

    );

    // onboarding seq observable
    this.subs.push(

      this.onboarding
        .crptOnbrdngSeq$
        .subscribe((seq) => {

          if (seq) {

            this.crptOnbrdngSeq =
              seq;

          }

        })

    );

  }

  // =====================================
  // DESTROY
  // =====================================

  ngOnDestroy(): void {

    this.subs.forEach(
      (s) => s.unsubscribe()
    );

  }

  // =====================================
  // NEXT
  // =====================================

  goNext(): void {

    if (!this.crptOnbrdngSeq) {
      return;
    }

    this.router.navigate(

      [
        '/onboarding/review-details',
        this.crptOnbrdngSeq,
      ],

      {
        queryParams: {

          clientSeq:
            this.clntSeq,

          ...(this.isViewMode
            ? { mode: 'view' }
            : {}),

        },
      }

    );

  }

}